export default "__VITE_PUBLIC_ASSET__65540aa1__"